export const annotNameIncludes = (a, includes) => a && a.Subject && (a.Subject.includes(includes) || a.constructor?.name.includes(includes));

export default annotNameIncludes;
